// @flow
import React, {Component} from 'react';
import {StyleSheet, Platform, Keyboard, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import config from '../../../config';

import I18n from '../../../lib/i18n';
import {GradientPage} from '../../../components/common';
import {PickNumber, KeepNumber} from './tabs';
import {SceneMap, TabBar, TabView} from 'react-native-tab-view';
import theme from '../../../theme-config';
import PageTitle from '../../../components/signUp/PageTitle';

class ChooseNumber extends Component<Props, *> {
  styles = getStyles();

  constructor() {
    super();
    const routes = [
      {key: 'pick', title: I18n.t('SignUp.ChooseNumber.tab.pick')},
    ];
    if (config.canKeepMyNumber) {
      routes.push({key: 'keep', title: I18n.t('SignUp.ChooseNumber.tab.keep')});
    }
    this.state = {
      index: 0,
      routes,
    };
  }

  _handleChangeTab = index => this.setState({index});

  _renderTabLabel = ({route}) => {
    const focused = this.state.routes.indexOf(route) === this.state.index;
    return (
      <Text
        style={[
          this.styles.tabLabelText,
          focused && this.styles.tabLabelTextFocused,
        ]}
        testID={route.key}>
        {route.title}
      </Text>
    );
  };

  _renderHeader = props => (
    <TabBar
      {...props}
      indicatorStyle={this.styles.tabIndicator}
      style={this.styles.tabHeader}
      pressOpacity={0.5}
      onTabPress={Keyboard.dismiss}
      tabBarPosition="top"
      renderLabel={this._renderTabLabel}
    />
  );

  _renderScene = SceneMap({
    pick: () => <PickNumber goToNextPage={this.props.goToNextPage} />,
    keep: () => <KeepNumber isActivationPath={this.props.isActivationPath} />,
  });

  render() {
    return (
      <GradientPage maxWidth={600}>
        <PageTitle
          title={I18n.t('SignUp.ChooseNumber.title')}
        />
        <View style={this.styles.contentContainer}>
          <TabView
          style={this.styles.tabContainer}
          navigationState={this.state}
          renderScene={this._renderScene}
          renderTabBar={this._renderHeader}
          onIndexChange={this._handleChangeTab}
          swipeEnabled={Platform.OS !== 'web'}
          useNativeDriver
        />
        </View>
      </GradientPage>
    );
  }
}

export type Props = DispatchProps & StateProps;

export type DispatchProps = {
  goToNextPage: Function,
};

export type StateProps = {
  isActivationPath?: boolean,
};

function getStyles() {
  return StyleSheet.create({
    contentContainer: {
      flex: 1,
      width: '100%'
    },
    tabContainer: {
      flex: 1,
      marginTop: 15,
    },
    tabHeader: {
      backgroundColor: 'transparent',
    },
    tabLabelText: {
      color: theme.secondaryColor,
      fontSize: 15,
      opacity: 1,
      textAlign: 'center',
    },
    tabLabelTextFocused: {
      fontSize: 15,
      fontWeight: 'bold',
    },
    tabIndicator: {
      borderBottomWidth: 2,
      borderBottomColor: theme.signUpTextColor,
    },
  });
}

export default ChooseNumber;
